import { BANKS } from "../../../../utils/banks";
import React, { Component } from 'react';
import { NumericFormat } from 'react-number-format';
import { ToastContainer, toast } from 'react-toastify';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import 'react-toastify/dist/ReactToastify.css';
import UtilService from '../../../../services/Celcoin/utilService';
import TedService from '../../../../services/Celcoin/tedService';
import { getTranslations } from '../../../../services/languageUtils';
import AccountManagerService from '../../../../services/Celcoin/accountManagerService';

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      translations: {},
      currentBalance: 0,
      password: '',
      amount: 0,
      bank: '',
      account: '',
      branch: '',
      branchDigit: '',
      taxId: '',
      name: '',
      accountType: '',
      personType: '',
      clientFinality: '',
      description: '',
      payment: {},
      show2FAModal: false,
      transferPending: false,
      twoFactorCode: '',
    };
  }

  bankList = BANKS;

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  handleScan = (data) => {
    if (data) {
      this.setState({ code: data.text || data });
    }
  };

  updateValueTransfer(value){
    this.setState({amount: Number(value)});
  }

  handleError = (err) => {
    this.setState({ error: this.state.translations.errorReadingCode });
  };

  proceed = (value) => {
    if(value === 1){
        if(document.getElementById("description").value === ""){
            return toast(this.state.translations.whenPurposeIsOthersMandatoryFillDescription, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: "error",
                theme: "light"
              });
        }
        this.setState({
            name: document.getElementById("name").value,
            bank: document.getElementById("bankCode").value,
            branch: document.getElementById("branch").value,
            branchDigit: document.getElementById("branchDigit").value,
            accountType: document.getElementById("accountype").value,
            account: document.getElementById("account").value,
            taxId: document.getElementById("document").value,
            description: document.getElementById("description").value
        });
    }
    this.props.onChangeValue({ target: { name: 'step', value } });
  }

  sendPayment(step) {
    this.setState({
      show2FAModal: true,
      transferPending: true,
      pendingStep: step,
      twoFactorCode: ''
    });
  }

  verify2FAForTransfer = async () => {
    if (this.state.twoFactorCode.length !== 6) {
      return this.toastMessage('error', this.state.translations.invalidCode || 'Código deve ter 6 dígitos');
    }

    this.setState({ loading2FA: true, loadingTranfer: true });

    try {
      await UtilService.verify2FAForTransaction(
        sessionStorage.getItem("emailUser"), 
        this.state.twoFactorCode
      );
      
      this.setState({ 
        show2FAModal: false, 
        loading2FA: false,
        twoFactorCode: '' 
      });
      
      this.confirmTransfer();
      
    } catch (error) {
      this.setState({ loading2FA: false, loadingTranfer: false });
      this.toastMessage('error', this.state.translations.invalid2FACode || 'Código 2FA inválido');
    }
  }

  cancel2FA = () => {
    this.setState({
      show2FAModal: false,
      twoFactorCode: '',
      loading2FA: false,
      transferPending: false,
      loadingTranfer: false
    });
  }

  confirmTransfer = async () => {
    const { pendingStep, amount, description, name, taxId, bank, branch, branchDigit, account, accountType } = this.state;

    try {
      const res = await TedService.createTed({
        transfer_type: "ted",
        amount_cents: parseInt(Number(amount) * 100),
        description,
        email: sessionStorage.getItem('emailUser'),
        conciliation_id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        receiver: {
          name,
          cpf_cnpj: taxId,
          bank: {
            ispb: bank,
            branch,
            account,
            account_type: accountType,
            bank_branch_digit: branchDigit
          }
        }
      });

      this.setState({ 
        payment: res.data.body, 
        loadingTranfer: false,
        show2FAModal: false,
        transferPending: false
      }, () => this.proceed(pendingStep));

    } catch (err) {
      console.error(err);
      this.setState({ loadingTranfer: false, show2FAModal: false, transferPending: false });
      toast(this.state.translations.errorProcessingPayment, { type: "error" });
    }
  }

  getMaskPass() {
    let that = this;
    let mask = '';
    for(let i=0; i<that.state.password.length; i++){
      mask = mask+'*';
    }
    return mask;
  }

  back = (value) => {
    this.props.onChangeValue({ target: { name: 'step', value } });
  };

  componentDidMount() {
    this.loadTranslations();
    this.updateBalance();
  }

  updateBalance() {
    let that = this;
    AccountManagerService.showBalance().then((res) => {
      that.setState({currentBalance: res.data.body.amount});
    }).catch((err) => {
      console.error(err);
    });
  }

  handleTwoFactorCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').substring(0, 6);
    this.setState({ twoFactorCode: value });
  }

  handleEnter2FA = (e) => {
    if (e.key === 'Enter' && this.state.twoFactorCode.length === 6) {
      this.verify2FAForTransfer();
    }
  }

  writePassword(caracter) {
    this.setState({password: caracter});
  }

  savePDF(resultPayment){
        const doc = new jsPDF();
      
        doc.text('Payment order resume', 14, 20);
    
        const tableColumn = ["Field", "Value"];
        const tableRows = [];
        const payment = this.state.payment;
    
        const addRow = (field, value) => {
            tableRows.push([field, value]);
        };
        addRow("ID", payment.id);
        addRow("Amount", payment.amount);
        addRow("Client Code", payment.clientCode);
        addRow("Status", "PROCESSING");

        // Dados do debitParty
        addRow("Debit Party - Bank", payment.debitParty.bank);
        addRow("Debit Party - Account", payment.debitParty.account);
        addRow("Debit Party - Branch", payment.debitParty.branch);
        addRow("Debit Party - Tax ID", payment.debitParty.taxId);
        addRow("Debit Party - Name", payment.debitParty.name);
        addRow("Debit Party - Account Type", payment.debitParty.accountType);
        addRow("Debit Party - Person Type", payment.debitParty.personType);

        // Dados do creditParty
        addRow("Credit Party - Bank", payment.creditParty.bank);
        addRow("Credit Party - Account", payment.creditParty.account);
        addRow("Credit Party - Branch", payment.creditParty.branch);
        addRow("Credit Party - Tax ID", payment.creditParty.taxId);
        addRow("Credit Party - Name", payment.creditParty.name);
        addRow("Credit Party - Account Type", payment.creditParty.accountType);
        addRow("Credit Party - Person Type", payment.creditParty.personType);

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 30,
      });
    
      doc.save(`payment_${payment.id}.pdf`);
  }

  render() {
   return (
    <section id="pixTransferComponent" className="pixTransferComponent" key={this.props.type}>
        {
          this.props.type === 'tedTransfer' &&
          this.props.step === 0 &&
          <div>
            <div className="mainContent100">
                <div className="diplay-inline">
                    <p>Banco</p>
                    <select
                      id="bankCode"
                      className="input"
                      style={{ maxWidth: "300px" }}
                      onChange={(e) => this.setState({ bank: e.target.value })}
                      value={this.state.bank}
                    >
                      <option value="">Selecione um banco</option>
                      {this.bankList.map((banco) => (
                        <option key={banco.ispb} value={banco.ispb}>
                          {banco.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="diplay-inline">
                    <p>
                        Número da conta (Somente números)
                    </p>
                    <input type="text" id="account" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="diplay-inline">
                    <p>
                        Agência (Sem digito verificador)
                    </p>
                    <input type="text" id="branch" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="diplay-inline">
                    <p>
                        {'Digito verificador da agência'}
                    </p>
                    <input type="text" id="branchDigit" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="diplay-inline">
                    <p>
                        {this.state.translations.documentCPFCNPJ} (Somente números)
                    </p>
                    <input type="text" id="document" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="diplay-inline">
                    <p>
                        {this.state.translations.name}
                    </p>
                    <input type="text" id="name" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="diplay-inline">
                    <p>
                        {this.state.translations.description}
                    </p>
                    <input type="text" id="description" className="input" style={{maxWidth: "300px"}} />
                </div>

                <div className="display-inline">
                  <p>Tipo de conta</p>
                  <select id="accountype" className="input" style={{ maxWidth: "300px" }}>
                    <option value="checking_account">Conta corrente</option>
                    <option value="salary_account">Conta salário</option>
                    <option value="savings_account">Conta poupança</option>
                    <option value="payment_account">Conta de pagamento</option>
                  </select>
                </div>
                
                <div className="buttonSend" onClick={() => {this.proceed(1)}}>
                    {this.state.translations.nextArrow}
                </div>
            </div>
          </div>
        }

        {
          this.props.step === 1 &&
          <div>
            <div className="mainContent">
              <p className="pTitle">
              {this.state.translations.paymentOrderResume}
              </p>
              <p className="pLabel">
                {this.state.name}
              </p>

              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.account}
                </p>
                <b>
                  {this.state.account}
                </b>
              </div>
              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.branch}
                </p>
                <b>
                  {this.state.branch}
                </b>
              </div>
              
              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.documentCPFCNPJ}
                </p>
                <b>
                  {this.state.taxId}
                </b>
              </div><br/><br/>
              <div onClick={() => {this.back(0)}} className="backButton">
                {this.state.translations.somethingWrong} <b>{this.state.translations.goBack}</b>
              </div>
            </div>

            <div className="mainContent" style={{ borderRadius: "0px 8px 8px 0px" }}>
              <p className="pTitle spaceBetween">
                <span>{this.state.translations.amount}</span>
                <span style={{ fontWeight: "700" }}>
                  {this.state.translations.currency_prefix} {this.state.currentBalance.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </span>
              </p><br/>
              <div style={{display: "flex", marginTop: "10px"}}>
                <div>
                    <span className="labelGray">{this.state.translations.how_much_transfer}</span>
                    <NumericFormat
                        className="input"
                        value={this.state.amount}
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix={this.state.translations.currency_prefix}
                        onValueChange={(values) => {
                        const { value } = values;
                        this.updateValueTransfer(value);
                        }}
                    />
                    </div>
                </div><br/>

              <div 
                className={`buttonSend ${this.state.loadingTranfer ? 'disabled' : ''}`} 
                onClick={!this.state.loadingTranfer ? () => {this.sendPayment(2)} : null}
              >
                {this.state.loadingTranfer ? <div className="loader"></div> : this.state.translations.complete_transfer}
              </div>
            </div>
          </div>
        }
        {
          this.props.step === 2 &&
          <div>
            <div className="mainContent">
              <p className="pTitle">
                {this.state.translations.transfer_order_resume}
              </p>

              <p className="pLabel">
                {this.state.name}
              </p>

              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.account}
                </p>
                <b>
                  {this.state.account}
                </b>
              </div>
              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.branch}
                </p>
                <b>
                  {this.state.branch}
                </b>
              </div>
              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.accountType}
                </p>
                <b>
                  {this.state.accountType}
                </b>
              </div>
              
              <div className="contentSpaceBetween">
                <p className="labelGray">
                {this.state.translations.documentCPFCNPJ}
                </p>
                <b>
                  {this.state.taxId}
                </b>
              </div><br/>
            </div>

            <div className="mainContent" style={{borderRadius: "0px 8px 8px 0px", textAlign: "center"}}>
              <br/><br/>
              <b>
                <img src={require("../../../../assets/imgs/ico-higher-bg.svg").default} alt={this.state.translations.success_icon_alt} className="imgSuccess" />
                {this.state.translations.transfer_completed_successfully}
              </b><br/><br/>
              <div className="buttonShare" style={{cursor: "pointer"}} onClick={() => {this.savePDF({})}}>
                {this.state.translations.save_receipt}
              </div>
            </div>
          </div>
        }
        {this.state.show2FAModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "24px",
                minWidth: "350px",
                maxWidth: "90%",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
                {this.state.translations.twoFactorAuthentication || 'Autenticação de Dois Fatores'}
              </h3>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                {this.state.translations.enterCodeFromApp || 'Digite o código de 6 dígitos do seu aplicativo autenticador:'}
              </p>
              
              <input
                type="text"
                value={this.state.twoFactorCode}
                onChange={this.handleTwoFactorCodeChange}
                onKeyDown={this.handleEnter2FA}
                maxLength="6"
                placeholder="000000"
                disabled={this.state.loading2FA}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "18px",
                  textAlign: "center",
                  letterSpacing: "4px",
                  border: "2px solid #ddd",
                  borderRadius: "6px",
                  margin: "16px 0",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
              
              <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "20px" }}>
                <button 
                  onClick={this.cancel2FA}
                  disabled={this.state.loading2FA}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #aaa",
                    color: "#555",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA ? "not-allowed" : "pointer",
                    opacity: this.state.loading2FA ? 0.6 : 1,
                  }}
                >
                  {this.state.translations.cancel || 'Cancelar'}
                </button>
                <button 
                  onClick={this.verify2FAForTransfer}
                  disabled={this.state.loading2FA || this.state.twoFactorCode.length !== 6}
                  style={{
                    backgroundColor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "#ccc" : "#1c787e",
                    border: "none",
                    color: "white",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA || this.state.twoFactorCode.length !== 6 ? "not-allowed" : "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.loading2FA ? (this.state.translations.verifying || 'Verificando...') : (this.state.translations.verify || 'Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}
      <ToastContainer />
    </section>
   );
  }
 }

export default Item;
